import './src/styles/fonts.css'
import './src/styles/global.css'
import './src/styles/tailwind.css'
import 'react-calendar/dist/Calendar.css'
import './src/styles/react-date-range.css'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)

import wrapWithProvider from './src/contextAndProviders/azureAuthProvider'
export const wrapRootElement = wrapWithProvider
